import { objectsRHandler } from '@/utils/objectsRHandler';

import EventTemplateConfig from '../list/event-template-config';

const API_PATH = 'event-template-configs';

export const EventTemplatesConfigManager = {
  objects: objectsRHandler(API_PATH, EventTemplateConfig),
};
